$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
    var $activeOuter = $(".product-selector_outer.active_block");
      var $activeBox = $activeOuter.find(".product-selector_block.active");


      var selectedIndex = $activeBox.index() + 1;

      var $config = $(".mp_coc_config--data");

      var domain = $config.attr("data-url");

      // dynamically gets data-id-1 / data-id-2 / data-id-3
      var productId = $config.attr("data-id-" + selectedIndex);

      var newUrl = domain + "?products=" + productId;

      console.log(selectedIndex);
      console.log(productId);
      console.log(newUrl);

      window.location.href = newUrl;

  });
});
